import { observer } from "mobx-react-lite";

import { HUGGINGFACE_PROVIDER } from "../constants";
import { useParameters } from "../store";

import { Label } from "@/components/ui/label";
import { ModelDropdown } from "@/components/ModelDropdown";
import { useAuth } from "@/context/auth-context";
import { useModelsStore } from "@/providers/ProviderAndModelsProvider/models-store";
import { useModelMetadata } from "@/queries/models/useModelMetadata";

export const LLMModel = observer(() => {
  const store = useParameters();
  const { store: modelsStore } = useModelsStore({});
  const { modelsLoading } = modelsStore;
  const { modelName, inferenceClientName } = store;
  const auth = useAuth();
  const { data: metadataResponse } = useModelMetadata(auth?.userToken ?? "");

  return (
    <div className="flex-0 mb-4 md:mb-0">
      <div className="mb-4">
        <Label htmlFor="version-select" className="mb-2 block text-sm font-medium text-gray-700">
          {store.provider?.name === HUGGINGFACE_PROVIDER ? "Inference Client" : "Model"}
        </Label>
        <div className="relative">
          <ModelDropdown
            selectedModel={inferenceClientName || modelName || ""}
            handleSelectModel={name => store.updateModelName(name)}
            models={store.models || []}
            provider={store.provider?.name || ""}
            isLoading={modelsLoading}
            selectedAPI={store.selectedAPI}
            metadataMap={metadataResponse?.models}
            providerMap={metadataResponse?.provider_map}
          />
        </div>
      </div>
    </div>
  );
});
